
export enum AccountConnectedStatus {
    NotConnectedYet = 0,
    Connected = 1,
    DisconnectedByUser = 2,
    DisconnectedByProvider = 3
}

export namespace EntityType {
    export function toString(connectedStatus: AccountConnectedStatus): string {
        switch (connectedStatus) {
            case AccountConnectedStatus.NotConnectedYet:
                return 'Not Connected Yet';
            case AccountConnectedStatus.Connected:
                return 'Connected';
                case AccountConnectedStatus.DisconnectedByUser:
                return 'Disconnected By User';
                case AccountConnectedStatus.DisconnectedByProvider:
                return 'Disconnected By Provider';
            default:
                return null;
        }
    }

    export function listAll() {
        return [
            AccountConnectedStatus.NotConnectedYet,
            AccountConnectedStatus.Connected,
            AccountConnectedStatus.DisconnectedByUser,
            AccountConnectedStatus.DisconnectedByProvider
        ];
    }

    export function parse(connectedStatusStr: string): AccountConnectedStatus {
        return AccountConnectedStatus[connectedStatusStr];
    }
}